'use client';

import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import HistoryIcon from '@mui/icons-material/History';
import DescriptionIcon from '@mui/icons-material/Description';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import TelegramIcon from '@mui/icons-material/Telegram';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ViewContainer from '../layouts/ViewContainer';
import { SvgIconProps } from '@mui/material/SvgIcon';

interface SupportViewProps {
    onBack: () => void;
    onNavigate: (view: string) => void;
}

interface MenuButtonProps {
    icon: React.ReactElement<SvgIconProps>; // Уточнили тип
    title: string;
    subtitle?: string;
    onClick: () => void;
}

const MenuButton = ({ icon, title, subtitle, onClick }: MenuButtonProps) => (
    <Paper
        onClick={onClick}
        elevation={0}
        sx={{
            p: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            transition: 'all 0.2s',
            '&:hover': {
                borderColor: 'primary.main',
                bgcolor: 'action.hover',
            },
            '&:active': {
                bgcolor: 'action.selected',
            }
        }}
    >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ 
                color: 'text.primary',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.05)', 
                width: 38,
                height: 38,
                borderRadius: '50%',
                flexShrink: 0,
            }}>
                {React.cloneElement(icon, { fontSize: 'small' })}
            </Box>
            <Box>
                <Typography variant="body2" fontWeight="bold" sx={{ lineHeight: 1.2 }}>{title}</Typography>
                {subtitle && (
                    <Typography 
                        variant="caption" 
                        color="text.secondary" 
                        sx={{ 
                            display: 'block', 
                            lineHeight: 1.2,
                            mt: 0.5
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>
        </Box>
        <ChevronRightIcon sx={{ color: 'text.secondary' }} fontSize="small" />
    </Paper>
);

export default function SupportView({ onBack, onNavigate }: SupportViewProps) {
  return (
    <ViewContainer title="Поддержка" onClose={onBack}>
      <Stack spacing={1.5}>
        <MenuButton 
            icon={<HistoryIcon />} 
            title="История операций" 
            subtitle="Пополнения и списания"
            onClick={() => onNavigate('transactions')} 
        />
        <MenuButton 
            icon={<DescriptionIcon />} 
            title="Публичная оферта" 
            subtitle="Правила использования сервиса"
            onClick={() => onNavigate('terms')} 
        />
        <MenuButton 
            icon={<HelpOutlineIcon />} 
            title="Не подключается?" 
            subtitle="Инструкция по устранению проблем"
            onClick={() => onNavigate('troubleshoot')}
        />
        
        <Box sx={{ pt: 1 }}>
            <Button 
                variant="contained" 
                size="medium"
                fullWidth
                startIcon={<TelegramIcon />}
                href="https://t.me/avadavpn_help"
                target="_blank"
                sx={{ 
                    py: 1.2,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontSize: '0.95rem',
                    fontWeight: 'bold'
                }}
            >
                Написать в поддержку
            </Button>
        </Box>
      </Stack>
    </ViewContainer>
  );
}
